import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import vinkLogo from '@/assets/vinklogo.png';

interface MossBrandProps {
    size?: 'tiny' | 'small' | 'large';
    /** 是否启用动效（默认 hover 触发） */
    animated?: boolean;
    /** 是否持续播放动效 */
    continuous?: boolean;
}

const MossBrand: React.FC<MossBrandProps> = ({
    size = 'large',
    animated = true,
    continuous = false,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const isTiny = size === 'tiny';
    const isSmall = size === 'small';

    // Logo sizes based on size prop - tiny 适配侧边栏顶部
    const logoHeight = isTiny ? 36 : isSmall ? 64 : 96;
    const shouldAnimate = animated && (continuous || isHovered);

    return (
        <div
            className="select-none relative"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                width: logoHeight,
                height: logoHeight,
            }}
        >
            {/* 光晕扩散层 */}
            <AnimatePresence>
                {shouldAnimate && (
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{
                            scale: [0.8, 1.4, 0.8],
                            opacity: [0.5, 0, 0.5],
                        }}
                        exit={{ opacity: 0 }}
                        transition={{
                            duration: 0.9,
                            repeat: Infinity,
                            ease: 'easeOut',
                        }}
                        style={{
                            position: 'absolute',
                            inset: '-20%',
                            borderRadius: '50%',
                            background: 'radial-gradient(circle, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.15) 40%, transparent 70%)',
                            pointerEvents: 'none',
                        }}
                    />
                )}
            </AnimatePresence>

            {/* Logo 图片 */}
            <motion.img
                src={vinkLogo}
                alt="Vink Logo"
                animate={shouldAnimate ? {
                    scale: [1, 1.05, 1],
                    opacity: [0.85, 1, 0.85],
                    rotate: [0, 0, 0, 360, 360], // 间歇旋转
                } : {
                    scale: 1,
                    opacity: 1,
                    rotate: 0,
                }}
                transition={{
                    scale: {
                        duration: 0.9,
                        repeat: shouldAnimate ? Infinity : 0,
                        ease: 'easeInOut',
                    },
                    opacity: {
                        duration: 0.9,
                        repeat: shouldAnimate ? Infinity : 0,
                        ease: 'easeInOut',
                    },
                    rotate: {
                        duration: 4,
                        repeat: shouldAnimate ? Infinity : 0,
                        ease: [0.4, 0, 0.2, 1],
                        times: [0, 0.4, 0.5, 0.7, 1],
                    },
                }}
                style={{
                    width: logoHeight,
                    height: logoHeight,
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1)',
                }}
            />
        </div>
    );
};

export default MossBrand;
